<script setup>
import { formatBytes, postMultipartXhr } from '@/common/util'
import { useMetaStore } from '@/stores'
import dayjs from 'dayjs'
import { onMounted, reactive } from 'vue'

const metaStore = useMetaStore()
const meta = reactive({
  msg: '레이어 파일을 업로드 중입니다.',
  stage:'upload',
  percent: 0,
  loadedBytes: 0,
  totalBytes: 0,
  speedBytesPerSec: 0,
  currentfn:'',
  xhr:null
})
const props = defineProps({newlayer:Object,onRslt:Function,toastId: Number})
const emit = defineEmits(['close-toast'])
function cancel(){
  meta.xhr.abort()
}
function onProgress({speedBytesPerSec,loadedBytes,totalBytes,percent}){
  meta.speedBytesPerSec=speedBytesPerSec
  meta.loadedBytes=loadedBytes
  meta.totalBytes=totalBytes
  meta.percent=percent
  if(meta.percent>=100)meta.stage='processing'
}
async function init() {
  const { xhr, promise } =postMultipartXhr('rest/authed/admin/data/addlayer',props.newlayer,onProgress)
  meta.xhr=xhr
  promise.then(res=>{
    emit('close-toast')
    props.onRslt(res)
  }).catch(err =>{
    emit('close-toast')
    props.onRslt({isSuccess:false})
  });
  meta.starttime=dayjs().format('YYYY-MM-DD HH:mm:ss')
}
onMounted(()=>init())
</script>
<template>
  <div style="width: 450px;">
    <p>{{ meta.msg }}</p>
    <div v-if="meta.stage=='upload'" class="progress-bar-background">
      <div class="progress-bar-fill" :style="{ width: meta.percent + '%' }"></div>
    </div>
    <p>{{ meta.currentfn }}</p>
    <p v-if="meta.stage=='upload'">{{ meta.percent.toFixed(2) }}% [{{ formatBytes(meta.loadedBytes,false,true) }} / {{ formatBytes(meta.totalBytes,false,true) }}]</p>
    <p v-if="meta.stage=='upload'">속도 {{ formatBytes(meta.speedBytesPerSec,false,true) }}</p>
    <p v-if="meta.stage=='upload'">남은용량 {{ formatBytes(meta.totalBytes - meta.loadedBytes,false,true) }}</p>
    <p v-if="meta.stage=='processing'">처리중 입니다.</p>
    <p>시작시간: {{ meta.starttime }}</p>
    <p>{{meta.checktime}}</p>
    <button v-if="meta.percent<90" @click="cancel" style="width: 100%;border: 1px solid #fff;">{{ metaStore.t('cancel') }}</button>
  </div>
</template>
<style scoped>
.progress-bar-background {
  width: 100%;
  height: 6px;
  background: #d1d5db;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 8px;
}
.progress-bar-fill {
  height: 100%;
  background: #3b82f6;
  transition: width 0.2s ease;
}
</style>
